import { get } from 'lodash'
import { useQuery } from 'react-query'
import { AxiosError } from 'axios'

import { fetchAPI } from '@/lib/api'

import { Prize } from '../types'
import { Meta } from '@/features/filters/types'

import { PRIZES } from '../constants'

type PrizeResponse = {
  data: Prize[]
  meta: Meta
}

const getPrizes = async (params: Meta): Promise<PrizeResponse> => {
  const response = await fetchAPI({
    path: `/prize_exchanges`,
    params,
  })

  const data = get(response, 'data.prize_exchanges', [])
  const meta = get(response, 'data.meta', {})

  return { data, meta }
}

export const usePrizes = ({
  params = {},
  initialData,
}: {
  params?: Meta
  initialData?: PrizeResponse
}) => {
  return useQuery<PrizeResponse, AxiosError>({
    queryKey: [PRIZES, params],
    queryFn: () => getPrizes(params),
    keepPreviousData: true,
    initialData,
  })
}
